export class SearchEvent {

    public selectedItemId: string;
    public isSearchSuccess: boolean;
    public message: string;
    public selectedProperty: string;
    public selectedRow: any;
    public pageSize: number;
    public pageNumber: number;
    public createdRowIndex: number;

    constructor(public type: number) { }

}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/models/search-event.ts